<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
    <defs>
      <clipPath id="t6o7szupaa">
        <path style="fill:none" d="M0 0h13.78v20.8H0z" />
      </clipPath>
    </defs>
    <g>
      <g style="clip-path:url(#t6o7szupaa)" transform="translate(6.067 2.6)">
        <path
          d="M6.24 7.54A5.313 5.313 0 0 0 3.654 9.3V0H0v20.8h3.655v-7.147c0-.021 0 .028 0 0A3.513 3.513 0 0 1 7.1 10.332a2.906 2.906 0 0 1 2.2.94 3.983 3.983 0 0 1 .873 2.654V20.8h3.607v-8.037a5.576 5.576 0 0 0-1.422-4.011 5.632 5.632 0 0 0-4.524-1.523 7.08 7.08 0 0 0-1.594.311"
          style="fill:#333"
        />
      </g>
    </g>
    <path style="fill:transparent" d="M0 0h26v26H0z" />
  </svg>
</template>

<script>
export default {
  name: 'ShortHiworksLogo',
};
</script>
